import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../store';

export interface UserState {
  access_token?: string;
  refresh_token?: string;
  user_data?: UserData;
}

export interface UserData {
  account_number: number;
  id: string;
  first_name: string;
  last_name: string;
  email: string;
  pic_url: string;
  user_account_settings: UserAccountSettings
}

export interface UserAccountSettings {
  auto_delete_zoom_recordings_on_sync: boolean
}

const initialState: UserState = {
  access_token: undefined,
  refresh_token: undefined,
  user_data: undefined
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setTokens: (state, action: PayloadAction<{ access_token: string, refresh_token: string }>) => {
      state.access_token = action.payload.access_token;
      state.refresh_token = action.payload.refresh_token;
    },
    setUserData: (state, action: PayloadAction<UserData | undefined>) => {
      state.user_data = action.payload;
    },
    setUserAccountSettings: (state, action: PayloadAction<UserAccountSettings>) => {
      if (state.user_data) state.user_data.user_account_settings = action.payload;
    }
  }
});

export const { setTokens, setUserData, setUserAccountSettings } = userSlice.actions;

export const updateUserAccountSettingsEv = {
  eventName: 'Update User Account Settings',
  onSuccess: [{ redux: true, action: setUserAccountSettings }]
}

export const selectAccessToken = (state: RootState) => state.user.access_token;
export const selectRefreshToken = (state: RootState) => state.user.refresh_token;

export default userSlice.reducer;
